import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "../../lib/site";

export const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="py-20 md:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="font-heading font-bold uppercase tracking-[0.2em] text-[#C8102E] text-sm">
          Questions
        </p>
        <h2 className="mt-2 font-heading text-4xl sm:text-5xl font-extrabold uppercase tracking-tight text-[#0E2A56]">
          Frequently Asked Questions
        </h2>

        <div className="mt-10 space-y-4">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border-2 border-[#0E2A56]">
                <button
                  data-testid={`faq-toggle-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 text-left px-6 py-5 bg-white hover:bg-[#F6F5F0] transition-colors"
                >
                  <span className="font-heading text-lg sm:text-xl font-bold uppercase tracking-tight text-[#0E2A56]">
                    {f.q}
                  </span>
                  <span className="shrink-0 inline-flex h-8 w-8 items-center justify-center bg-[#C8102E] text-white">
                    {isOpen ? <Minus className="h-5 w-5" strokeWidth={3} /> : <Plus className="h-5 w-5" strokeWidth={3} />}
                  </span>
                </button>
                {isOpen && (
                  <div data-testid={`faq-answer-${i}`} className="px-6 pb-6 pt-1 text-slate-700 leading-relaxed border-t-2 border-[#F6F5F0]">
                    {f.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
